import { Api } from "./api/api";
import { Items } from "../mocks/providers/items";
import { Settings } from "./settings/settings";
import { UserProvider } from "./user/user.provider";
import { LoggerService } from "./logger-service";
import { MenuProvider } from "./menu/menu.provider";
import { PermissionService } from "./permission-service";

export { Api, Items, Settings, UserProvider, LoggerService, MenuProvider, PermissionService };



// WEBPACK FOOTER //
// ./src/providers/providers.ts